import { ZollAPIService } from '../../../services/zollApi.service'
import { zollBaseURL } from '../../../services/api.service'
import { ZollApiResponse } from '../../zollApi/store/zollApi.types'
import { IGlobalDataDocMetadata } from '../../../services/globalIndexDb.service'

const GlobalDataPaginationUrl = `${zollBaseURL}/api/GlobalData/retrievePagination`
const GlobalDataImportUrl = `${zollBaseURL}/api/GlobalData/retrieve`

export interface IGlobalDataResponse extends ZollApiResponse {
  data: GlobalDataResponseDocs
}

export type GlobalDataResponseDocs = Array<IGlobalDataResponseDoc>

export interface IGlobalDataResponseDoc extends IGlobalDataDocMetadata {
  docData: any
}

export interface IGlobalDataPage {
  page: number
  docIds: Array<string>
}

export interface IGlobalDataPaginationResponse extends ZollApiResponse {
  data: Array<IGlobalDataPage>
}

export type GlobalDataInfoList = Array<{ id: string; lastUpdatedTime: string }>

export interface IGlobalDataRequest {
  globalData: GlobalDataInfoList
}

export class GlobalDataImportService extends ZollAPIService {
  async getGlobalDataPagination(data: IGlobalDataRequest): Promise<IGlobalDataResponse> {
    return this.postWithError(GlobalDataPaginationUrl, data)
  }

  async getGlobalData(data: IGlobalDataRequest): Promise<IGlobalDataResponse> {
    return this.postWithError(GlobalDataImportUrl, data)
  }
}
